import React from 'react';
import { Field } from 'redux-form';

import { NextBillingDateSelect, InputRadioWithSelect, InputRadioWithFieldFreeze } from '.'
import { isRequired } from '../../lib/forms/Validations';
import { InputDateWithFilter } from '../../lib/forms';



const ActiveFreeze = ({ hasFutureFreeze, isFrozen, translate, nextBillingDate, dayAfterNextBillingDate, cancel, startDate, endDate , category}) => {
  if (hasFutureFreeze){
    return (
      <div>
        <div className="form-group row">
          <div className="form-text form-group" >
            <span >{translate('update-freeze-subtitle')}</span>
          </div>

        </div>
        <div className="form-group row mispari-border ">
          <div className="col-md-7 font-weight-bold">
            <label>{translate('do-you-want-cancel-freeze')}</label>
          </div>
          <div className="col text-left mispari-field">
            <button className="btn btn-danger" type="button" data-target=".bd-cancel-freeze-lg" data-toggle="modal"  >{translate('cancel-the-freeze-button')}</button>
          </div>
        </div>
        <div className="form-group row mispari-border ">
          <label className="col-12 col-md-7 font-weight-bold" ><span>{translate('freeze-selecte-date-first')}</span></label>
          <div className="col-8 col-md-5 form-group">
            <Field name="start" radioName="start" label="nom" translate={translate} hasFutureFreeze={hasFutureFreeze} component={InputRadioWithSelect} NextBillingDate={nextBillingDate} defaultDate={startDate} type="date"  />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-12 col-md-7 font-weight-bold">{translate('freeze-selecte-date-last')}<small className="text-muted ml-1">{`(${translate('optional')})`}</small></label>
          <div className="col-8 col-md-5 form-group">
            <Field name="end" label="nom" placeholder={translate('select-date')}  component={InputDateWithFilter}  min={dayAfterNextBillingDate} className="form-control" type="date"/>
          </div>
        </div>
        <div className="form-group row form-group-warning">
          <div className="col">
            <small className="form-text text-muted">
              <strong>{translate('important-information')}:</strong>
              <span className="ml-1">{category === 'TV' ? translate('freeze-request-tv-info-message') : translate('freeze-request-info-message')}</span>
            </small>
          </div>
        </div>
        <div className="row-btn form-line edit">
        <div className="row justify-content-end row-btn">
          <div className="col-6 col-md-3">
            <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
          </div>
          <div className="col-6 col-md-3">
            <button className="btn btn-block btn-form btn-submit btn-submit-save " type="button" data-target=".bd-example-modal-lg" data-toggle="modal"  >{translate('save')}</button>
          </div>
        </div>
        </div>
      </div>
    )
  }
  else if (isFrozen) {
    return (
    <div>
      <div className="form-group row">
        <div className="form-text form-group" >
          <span >{translate('update-freeze-subtitle')}</span>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-12 col-md-7 font-weight-bold">{translate('freeze-selecte-date-last')}</label>
        <div className="col-8 col-md-5 form-group">
          <Field name="end" radioName="end"  label="nom"  option1={translate('now')} hasFuture={hasFutureFreeze} activeDate={endDate}  component={InputRadioWithFieldFreeze} min={dayAfterNextBillingDate} className="form-control" type="date" validate={[ isRequired]}  />
        </div>
      </div>
      <div className="row-btn form-line edit">
      <div className="row justify-content-end row-btn">
        <div className="col-6 col-md-3">
          <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
        </div>
        <div className="col-6 col-md-3">
          <button className="btn btn-block btn-form btn-submit btn-submit-save " type="button" data-target=".bd-example-modal-lg" data-toggle="modal"  >{translate('save')}</button>
        </div>
      </div>
      </div>
    </div>
  )
  }
  return (
    <div>
      <div className="form-group row">
        <div className="form-text form-group" >
          <span >{translate('freeze-request-subtitle')}</span>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-12 col-md-7 font-weight-bold" ><span>{translate('freeze-selecte-date-first')}</span></label>
        <div className="col-8 col-md-5 form-group">
          <Field name="start" label="nom" translate={translate} component={NextBillingDateSelect} NextBillingDate={nextBillingDate}  type="date"  />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-12 col-md-7 font-weight-bold">{translate('freeze-selecte-date-last')}<small className="text-muted ml-1">{`(${translate('optional')})`}</small></label>
        <div className="col-8 col-md-5 form-group">
          <Field name="end" label="nom"  placeholder={translate('select-date')}  component={InputDateWithFilter} min={dayAfterNextBillingDate} className="form-control" type="date" />
        </div>
      </div>
      <div className="form-group row form-group-warning">
        <div className="col">
          <small className="form-text text-muted">
            <strong>{translate('important-information')}:</strong>
            <span className="ml-1">{category === 'TV' ? translate('freeze-request-tv-info-message') : translate('freeze-request-info-message')}</span>
          </small>
        </div>
      </div>
      <div className="row-btn form-line edit">
      <div className="row justify-content-end row-btn">
        <div className="col-6 col-md-3">
          <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
        </div>
        <div className="col-6 col-md-3">
          <button className="btn btn-block btn-form btn-submit btn-submit-save " type="button" data-target=".bd-example-modal-lg" data-toggle="modal"  >{translate('save')}</button>
        </div>
      </div>
      </div>
    </div>
  )

}
export default ActiveFreeze;



// WEBPACK FOOTER //
// ./src/components/Freeze/ActiveFreeze.js